import AnnouncementIcon from "@material-ui/icons/Announcement";
import { token } from "functions/Helper";
import AnnouncementList from "views/Announcement/AnnouncementList";
import AnnouncementDetail, {
  DeleteAnnouncement
} from "views/Announcement/AnnouncementDetail";
import CreateAnnouncement from "views/Announcement/CreateAnnouncement";
import EditAnnouncement from "views/Announcement/EditAnnouncement";
import UploadAnnouncementBanner from "views/Announcement/UploadAnnouncementBanner";
import RemoveAnnouncementBanner from "views/Announcement/RemoveAnnouncementBanner";

const canRead = () =>
  token["booking.announcements.read"] === "allowed" ||
  token.is_admin === "True";

const canWrite = () =>
  token["booking.announcements.write"] === "allowed" ||
  token.is_admin === "True";

const announcement = () => {
  if (!canRead()) return [];

  return [
    {
      path: "/Announcement/List",
      name: "Announcements",
      icon: AnnouncementIcon,
      component: AnnouncementList,
      layout: "/admin"
    }
  ];
};

const announcementHidden = () => {
  let views = [];

  if (canRead()) {
    views.push({
      path: "/Announcement/Detail",
      name: "Announcement Detail",
      component: AnnouncementDetail,
      layout: "/admin",
      params: [{ name: "id" }]
    });
  }

  if (canWrite()) {
    views = views.concat([
      {
        path: "/Announcement/Create",
        name: "Create Announcement",
        component: CreateAnnouncement,
        layout: "/admin"
      },
      {
        path: "/Announcement/Edit",
        name: "Edit Announcement",
        component: EditAnnouncement,
        layout: "/admin",
        params: [{ name: "id" }]
      },
      {
        path: "/Announcement/Delete",
        name: "Delete Announcement",
        component: DeleteAnnouncement,
        layout: "/admin",
        params: [{ name: "id" }]
      },
      {
        path: "/Announcement/UploadBanner",
        name: "Upload Announcement Banner",
        component: UploadAnnouncementBanner,
        layout: "/admin",
        params: [{ name: "id" }]
      },
      {
        path: "/Announcement/RemoveBanner",
        name: "Remove Announcement Banner",
        component: RemoveAnnouncementBanner,
        layout: "/admin",
        params: [{ name: "id" }]
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "Announcement Hidden",
        state: "announcementHidden",
        hideInSidebar: true,
        views: views
      }
    ];

  return [];
};

export { announcement, announcementHidden };
